import React, { useCallback, useState, useMemo } from 'react';
import { Datagrid, TextField, List, ReferenceField } from 'react-admin';

import { ListPagination } from '../../core/components/list/ListPagination';
import Empty from '../../core/components/list/Empty';
import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import AddCategories from './AddCategories';

const CategoryTermsRelations = ({
  id: categoryTermId,
  permissions = [],
  ...rest
}) => {
  const [version, setVersion] = useState(0);

  const {
    hasCreate,
    hasShow,
    hasEdit,
    hasList,
    variant,
    ...datagridProps
  } = rest;

  const hasWriteCategoryTermRelationPermission = useMemo(() => {
    return permissions.includes('AUTH_WRITE_CATEGORY_TERM_AND_CONDITION');
  }, [permissions]);

  // We store a version in the state to be able to refrehs the list on adding funds
  const handleChange = useCallback(() => setVersion(version + 1), [version]);

  return (
    <List
      key={version}
      style={{ margin: '0px', width: '100%' }}
      pagination={<ListPagination />}
      {...rest}
      resource="categorytermsrelations"
      filter={{
        categoryTermIds: categoryTermId,
        orphanVisibility: 'ALL_VISIBLE'
      }}
      sort={{ field: 'categoryTermId', order: 'ASC' }}
      title=" "
      actions={
        hasWriteCategoryTermRelationPermission ? (
          <AddCategories
            key="addCategories"
            categoryTermId={categoryTermId}
            onChange={handleChange}
          />
        ) : null
      }
      bulkActionButtons={
        hasWriteCategoryTermRelationPermission ? (
          <BulkActionDeleteButton />
        ) : null
      }
      empty={
        <Empty
          emptyText="There are no categories to display"
          buttons={
            hasWriteCategoryTermRelationPermission
              ? [
                  <AddCategories
                    key="addCategories"
                    categoryTermId={categoryTermId}
                    onChange={handleChange}
                  />
                ]
              : []
          }
          title="Related Categories"
        />
      }
    >
      <Datagrid
        {...datagridProps}
        isRowSelectable={() => hasWriteCategoryTermRelationPermission}
      >
        <ReferenceField
          source="categoryId"
          reference="categories"
          link={false}
          label="Category Name"
          sortable={false}
          {...datagridProps}
        >
          <TextField source="name" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
};

export default CategoryTermsRelations;
